

if(window.location.pathname.includes('whats-on')){

    // Scroll to top of what's on page to restart the lazy load
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }

    // Create a new IntersectionObserver object
    const observer = new IntersectionObserver(function (entries, observer) {
        for (let entry of entries) {
            // When event container is in view
            if(entry.isIntersecting) {
                // Add show class to load in the event container
                entry.target.classList.add('troxy-lazy-load-container__show');
            }
        }
    });

    // Get all event containers 
    const eventMonthContainers = [...document.querySelectorAll('.troxy-whatson-month-section')];

    // Loop through containers 
    eventMonthContainers.forEach((container, index) => {
        // Start observering the containers in order to add show class
        observer.observe(container);
    })

    // Get all direct children within the lazy loading container e.g h2, article
    const childrenToLazyLoad = [...document.querySelectorAll('.troxy-lazy-container > *')];

    window.onscroll = () => {
        // Loop through all children cards to lazy load
        childrenToLazyLoad.forEach(element => {

            // Find offset of element using top position and the windwo dimensions
            const offset = element.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;

            // If offset is within the window then add the lazy load class
            if (window.pageYOffset > offset) {
               const img = element.querySelector('.troxy-whatson-card__upper__img > img');
                if(img) {
                    img.src = img.dataset.src; 
                }
                element.classList.add('troxy-lazy-load');
            }
        })
    }    
}